export default __webpack_public_path__ + "static/media/sweets-2.b8150107.jpeg";